/**
 * How captured OrderWerks payments are pushed to QuickBooks Online.
 *
 * - OFF: payments are never sent to QBO.
 * - INVOICE_DEPOSIT (legacy default): the first captured payment is sent as the `Deposit` field on the
 *   invoice when the invoice is created. Requires the QBO "Deposit" sales-form preference to be on.
 * - IMMEDIATE: a QBO Payment entity is created as soon as the payment is captured (an unapplied
 *   customer credit if the invoice doesn't exist yet) and linked to the invoice once it exists.
 * - ON_INVOICE: a QBO Payment entity is created and applied when the invoice is created.
 */
enum QBOPaymentSyncModeEnum {
    OFF = "off",
    INVOICE_DEPOSIT = "invoice_deposit",
    IMMEDIATE = "immediate",
    ON_INVOICE = "on_invoice",
}

export default QBOPaymentSyncModeEnum;
